//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ROLES_API_BASE_URL = new InjectionToken<string>('ROLES_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class RolesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ROLES_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCompanies(): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @return Success
     */
    getResources(application?: string | undefined): Observable<ResourcesResponseDto[]> {
        let url_ = this.baseUrl + "/api/resources?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResourcesResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResourcesResponseDto[]>;
        }));
    }

    protected processGetResources(response: HttpResponseBase): Observable<ResourcesResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourcesResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPermissionActions(): Observable<ActionsDto[]> {
        let url_ = this.baseUrl + "/api/resources/v2/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionsDto[]>;
        }));
    }

    protected processGetPermissionActions(response: HttpResponseBase): Observable<ActionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEndpointHierarchicalPermissions(): Observable<EndpointPermissionsDto[]> {
        let url_ = this.baseUrl + "/api/resources/v2/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEndpointHierarchicalPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEndpointHierarchicalPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndpointPermissionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndpointPermissionsDto[]>;
        }));
    }

    protected processGetAllEndpointHierarchicalPermissions(response: HttpResponseBase): Observable<EndpointPermissionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndpointPermissionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEndpointHierarchicalPermissionsTree(): Observable<EndpointHierarchicalPermissionResponseDto[]> {
        let url_ = this.baseUrl + "/api/resources/v2/permissionstree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEndpointHierarchicalPermissionsTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEndpointHierarchicalPermissionsTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndpointHierarchicalPermissionResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndpointHierarchicalPermissionResponseDto[]>;
        }));
    }

    protected processGetAllEndpointHierarchicalPermissionsTree(response: HttpResponseBase): Observable<EndpointHierarchicalPermissionResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndpointHierarchicalPermissionResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @return Success
     */
    getRoles(application?: string | undefined): Observable<RolesDto[]> {
        let url_ = this.baseUrl + "/api/roles?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesDto[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RolesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertRole(body?: UpsertRoleCommand | undefined): Observable<RolesResponse> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesResponse>;
        }));
    }

    protected processUpsertRole(response: HttpResponseBase): Observable<RolesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RolesResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteRole(body?: RoleIdDto[] | undefined): Observable<IResponse> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResponse>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<IResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = IResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoleById(roleId: number): Observable<RolesResponseDto> {
        let url_ = this.baseUrl + "/api/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesResponseDto>;
        }));
    }

    protected processGetRoleById(response: HttpResponseBase): Observable<RolesResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoleCompanies(roleId: number): Observable<RoleCompaniesDto> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/companies";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleCompaniesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleCompaniesDto>;
        }));
    }

    protected processGetRoleCompanies(response: HttpResponseBase): Observable<RoleCompaniesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleCompaniesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignCompanyToRole(roleId: number, body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/companies";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCompanyToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCompanyToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignCompanyToRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    unassignCompanyToRole(roleId: number, body?: string[] | undefined): Observable<IResponse> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/companies";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignCompanyToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignCompanyToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResponse>;
        }));
    }

    protected processUnassignCompanyToRole(response: HttpResponseBase): Observable<IResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = IResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoleExternalKeyTypePermissions(roleId: number): Observable<RoleExternalKeyTypePermissionsDto> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/externalkeytypepermissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleExternalKeyTypePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleExternalKeyTypePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleExternalKeyTypePermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleExternalKeyTypePermissionsDto>;
        }));
    }

    protected processGetRoleExternalKeyTypePermissions(response: HttpResponseBase): Observable<RoleExternalKeyTypePermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleExternalKeyTypePermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignExternalKeyTypePermissionstoRole(roleId: number, body?: ExternalKeyPermissionsRequestDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/externalKeyTypePermissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignExternalKeyTypePermissionstoRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignExternalKeyTypePermissionstoRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignExternalKeyTypePermissionstoRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRolePermissions(roleId: number): Observable<RolePermissionsDto> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionsDto>;
        }));
    }

    protected processGetRolePermissions(response: HttpResponseBase): Observable<RolePermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolePermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignPermissionsToRole(roleId: number, body?: RolePermissionsReqDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignPermissionsToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignPermissionsToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignPermissionsToRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    unassignPermissionsFromRole(roleId: number, body?: RolePermissionsReqDto[] | undefined): Observable<IResponse> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignPermissionsFromRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignPermissionsFromRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResponse>;
        }));
    }

    protected processUnassignPermissionsFromRole(response: HttpResponseBase): Observable<IResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = IResponse.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @param body (optional) 
     * @return Success
     */
    getUnassignedUsersForRole(roleId: number, application?: string | undefined, body?: FilterRequest | undefined): Observable<UsersDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/unassignedusers?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedUsersForRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedUsersForRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDtoGridResponseBase>;
        }));
    }

    protected processGetUnassignedUsersForRole(response: HttpResponseBase): Observable<UsersDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsersByRole(roleId: number, body?: FilterRequest | undefined): Observable<UsersDto[]> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/users";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto[]>;
        }));
    }

    protected processGetUsersByRole(response: HttpResponseBase): Observable<UsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    upsertApiPermissions(apiName: string): Observable<ApiPermissionResponse> {
        let url_ = this.baseUrl + "/api/Roles/ApiPermissions/{apiName}";
        if (apiName === undefined || apiName === null)
            throw new Error("The parameter 'apiName' must be defined.");
        url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertApiPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertApiPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiPermissionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiPermissionResponse>;
        }));
    }

    protected processUpsertApiPermissions(response: HttpResponseBase): Observable<ApiPermissionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPermissionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRolesCompanies(): Observable<RoleCompaniesDto> {
        let url_ = this.baseUrl + "/api/roles/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleCompaniesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleCompaniesDto>;
        }));
    }

    protected processGetRolesCompanies(response: HttpResponseBase): Observable<RoleCompaniesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleCompaniesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkPermission(body?: CheckPermissionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/permission/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRolesByUserObjectId(userObjectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/user/{userObjectId}";
        if (userObjectId === undefined || userObjectId === null)
            throw new Error("The parameter 'userObjectId' must be defined.");
        url_ = url_.replace("{userObjectId}", encodeURIComponent("" + userObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesByUserObjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesByUserObjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRolesByUserObjectId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authorizeV1(body?: AuthorizeRequest | undefined): Observable<AuthorizeResponse> {
        let url_ = this.baseUrl + "/api/Roles/v1/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorizeV1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorizeV1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizeResponse>;
        }));
    }

    protected processAuthorizeV1(response: HttpResponseBase): Observable<AuthorizeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authorize21(body?: AuthorizeRequest | undefined): Observable<AuthorizeResponse> {
        let url_ = this.baseUrl + "/api/Roles/v2.1/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize21(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize21(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizeResponse>;
        }));
    }

    protected processAuthorize21(response: HttpResponseBase): Observable<AuthorizeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authorize22(body?: AuthorizeRequest | undefined): Observable<AuthorizeResponse> {
        let url_ = this.baseUrl + "/api/Roles/v2.2/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize22(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize22(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizeResponse>;
        }));
    }

    protected processAuthorize22(response: HttpResponseBase): Observable<AuthorizeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoleAssignedHierarchicalPermissions(roleId: number): Observable<HierarchicalPermissionDto> {
        let url_ = this.baseUrl + "/api/Roles/v2/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleAssignedHierarchicalPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleAssignedHierarchicalPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HierarchicalPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HierarchicalPermissionDto>;
        }));
    }

    protected processGetRoleAssignedHierarchicalPermissions(response: HttpResponseBase): Observable<HierarchicalPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HierarchicalPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignHierarchicalPermissionsToRole(body?: RoleHierarchicalPermissionsRequest | undefined): Observable<ApiPermissionResponse> {
        let url_ = this.baseUrl + "/api/Roles/v2/permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignHierarchicalPermissionsToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignHierarchicalPermissionsToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiPermissionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiPermissionResponse>;
        }));
    }

    protected processAssignHierarchicalPermissionsToRole(response: HttpResponseBase): Observable<ApiPermissionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPermissionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum Action {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ActionsDto implements IActionsDto {
    actionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    implicitActionId?: number | undefined;

    constructor(data?: IActionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.implicitActionId = _data["implicitActionId"];
        }
    }

    static fromJS(data: any): ActionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["implicitActionId"] = this.implicitActionId;
        return data;
    }
}

export interface IActionsDto {
    actionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    implicitActionId?: number | undefined;
}

export class ApiPermissionResponse implements IApiPermissionResponse {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IApiPermissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiPermissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPermissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiPermissionResponse {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class ApplicationDto implements IApplicationDto {
    applicationId?: number;
    name?: string | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplicationDto {
    applicationId?: number;
    name?: string | undefined;
}

export class AuthorizeRequest implements IAuthorizeRequest {
    userObjectId?: string;
    apiName?: string | undefined;
    urlTemplate?: string | undefined;
    impersonatedPersonId?: string | undefined;
    method?: string | undefined;
    companyName?: string | undefined;
    currentRole?: string | undefined;

    constructor(data?: IAuthorizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userObjectId = _data["userObjectId"];
            this.apiName = _data["apiName"];
            this.urlTemplate = _data["urlTemplate"];
            this.impersonatedPersonId = _data["impersonatedPersonId"];
            this.method = _data["method"];
            this.companyName = _data["companyName"];
            this.currentRole = _data["currentRole"];
        }
    }

    static fromJS(data: any): AuthorizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userObjectId"] = this.userObjectId;
        data["apiName"] = this.apiName;
        data["urlTemplate"] = this.urlTemplate;
        data["impersonatedPersonId"] = this.impersonatedPersonId;
        data["method"] = this.method;
        data["companyName"] = this.companyName;
        data["currentRole"] = this.currentRole;
        return data;
    }
}

export interface IAuthorizeRequest {
    userObjectId?: string;
    apiName?: string | undefined;
    urlTemplate?: string | undefined;
    impersonatedPersonId?: string | undefined;
    method?: string | undefined;
    companyName?: string | undefined;
    currentRole?: string | undefined;
}

export class AuthorizeResponse implements IAuthorizeResponse {
    roles?: string[] | undefined;
    identityClaims?: IdentityClaims;
    companies?: string[] | undefined;

    constructor(data?: IAuthorizeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.identityClaims = _data["identityClaims"] ? IdentityClaims.fromJS(_data["identityClaims"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthorizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["identityClaims"] = this.identityClaims ? this.identityClaims.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        return data;
    }
}

export interface IAuthorizeResponse {
    roles?: string[] | undefined;
    identityClaims?: IdentityClaims;
    companies?: string[] | undefined;
}

export class CheckPermissionRequest implements ICheckPermissionRequest {
    userObjectId?: string | undefined;
    permissions?: Permission[] | undefined;

    constructor(data?: ICheckPermissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userObjectId = _data["userObjectId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckPermissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPermissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userObjectId"] = this.userObjectId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheckPermissionRequest {
    userObjectId?: string | undefined;
    permissions?: Permission[] | undefined;
}

export class CompanyDto implements ICompanyDto {
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyDto {
    companyId?: number;
    companyName?: string | undefined;
}

export class EndpointHierarchicalPermissionResponseDto implements IEndpointHierarchicalPermissionResponseDto {
    text?: string | undefined;
    description?: string | undefined;
    items?: EndpointHierarchicalPermissionResponseDto[] | undefined;

    constructor(data?: IEndpointHierarchicalPermissionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.description = _data["description"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EndpointHierarchicalPermissionResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EndpointHierarchicalPermissionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndpointHierarchicalPermissionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["description"] = this.description;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEndpointHierarchicalPermissionResponseDto {
    text?: string | undefined;
    description?: string | undefined;
    items?: EndpointHierarchicalPermissionResponseDto[] | undefined;
}

export class EndpointPermissionsDto implements IEndpointPermissionsDto {
    permissionPath?: string | undefined;
    description?: string | undefined;

    constructor(data?: IEndpointPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionPath = _data["permissionPath"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EndpointPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndpointPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionPath"] = this.permissionPath;
        data["description"] = this.description;
        return data;
    }
}

export interface IEndpointPermissionsDto {
    permissionPath?: string | undefined;
    description?: string | undefined;
}

export class ExternKeyPermissionResponseDto implements IExternKeyPermissionResponseDto {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    permission?: string | undefined;
    company?: string | undefined;

    constructor(data?: IExternKeyPermissionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalKeyTypePermissionsId = _data["externalKeyTypePermissionsId"];
            this.externalKeyTypeCode = _data["externalKeyTypeCode"];
            this.permission = _data["permission"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): ExternKeyPermissionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternKeyPermissionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalKeyTypePermissionsId"] = this.externalKeyTypePermissionsId;
        data["externalKeyTypeCode"] = this.externalKeyTypeCode;
        data["permission"] = this.permission;
        data["company"] = this.company;
        return data;
    }
}

export interface IExternKeyPermissionResponseDto {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    permission?: string | undefined;
    company?: string | undefined;
}

export class ExternalKeyPermissionsRequestDto implements IExternalKeyPermissionsRequestDto {
    externalKeyTypeCode?: string | undefined;
    permission?: string | undefined;
    company?: string | undefined;

    constructor(data?: IExternalKeyPermissionsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalKeyTypeCode = _data["externalKeyTypeCode"];
            this.permission = _data["permission"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): ExternalKeyPermissionsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyPermissionsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalKeyTypeCode"] = this.externalKeyTypeCode;
        data["permission"] = this.permission;
        data["company"] = this.company;
        return data;
    }
}

export interface IExternalKeyPermissionsRequestDto {
    externalKeyTypeCode?: string | undefined;
    permission?: string | undefined;
    company?: string | undefined;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
}

export class HierarchicalPermissionDto implements IHierarchicalPermissionDto {
    permissions?: string[] | undefined;
    deniedPermissions?: string[] | undefined;

    constructor(data?: IHierarchicalPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["deniedPermissions"])) {
                this.deniedPermissions = [] as any;
                for (let item of _data["deniedPermissions"])
                    this.deniedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): HierarchicalPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchicalPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.deniedPermissions)) {
            data["deniedPermissions"] = [];
            for (let item of this.deniedPermissions)
                data["deniedPermissions"].push(item);
        }
        return data;
    }
}

export interface IHierarchicalPermissionDto {
    permissions?: string[] | undefined;
    deniedPermissions?: string[] | undefined;
}

export class IResponse implements IIResponse {
    readonly isSuccess?: boolean;
    action?: Action;

    constructor(data?: IIResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isSuccess = _data["isSuccess"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): IResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["action"] = this.action;
        return data;
    }
}

export interface IIResponse {
    isSuccess?: boolean;
    action?: Action;
}

export class IdentityClaims implements IIdentityClaims {
    personId?: string | undefined;
    jobTitle?: string | undefined;

    constructor(data?: IIdentityClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any): IdentityClaims {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface IIdentityClaims {
    personId?: string | undefined;
    jobTitle?: string | undefined;
}

export class Permission implements IPermission {
    permissionId?: number;
    entity?: string | undefined;
    action?: string | undefined;
    scope?: string | undefined;
    applicationId?: number;
    readonly resourcePath?: string | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.entity = _data["entity"];
            this.action = _data["action"];
            this.scope = _data["scope"];
            this.applicationId = _data["applicationId"];
            (<any>this).resourcePath = _data["resourcePath"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["entity"] = this.entity;
        data["action"] = this.action;
        data["scope"] = this.scope;
        data["applicationId"] = this.applicationId;
        data["resourcePath"] = this.resourcePath;
        return data;
    }
}

export interface IPermission {
    permissionId?: number;
    entity?: string | undefined;
    action?: string | undefined;
    scope?: string | undefined;
    applicationId?: number;
    resourcePath?: string | undefined;
}

export class PermissionDto implements IPermissionDto {
    permissionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IPermissionDto {
    permissionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ResourceAttributeDto implements IResourceAttributeDto {
    resourceAttributesId?: number;
    resourceId?: number | undefined;
    path?: string | undefined;
    cssclassName?: string | undefined;
    isAuthorized?: boolean | undefined;
    displayOrder?: number | undefined;
    isInternal?: boolean | undefined;

    constructor(data?: IResourceAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceAttributesId = _data["resourceAttributesId"];
            this.resourceId = _data["resourceId"];
            this.path = _data["path"];
            this.cssclassName = _data["cssclassName"];
            this.isAuthorized = _data["isAuthorized"];
            this.displayOrder = _data["displayOrder"];
            this.isInternal = _data["isInternal"];
        }
    }

    static fromJS(data: any): ResourceAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceAttributesId"] = this.resourceAttributesId;
        data["resourceId"] = this.resourceId;
        data["path"] = this.path;
        data["cssclassName"] = this.cssclassName;
        data["isAuthorized"] = this.isAuthorized;
        data["displayOrder"] = this.displayOrder;
        data["isInternal"] = this.isInternal;
        return data;
    }
}

export interface IResourceAttributeDto {
    resourceAttributesId?: number;
    resourceId?: number | undefined;
    path?: string | undefined;
    cssclassName?: string | undefined;
    isAuthorized?: boolean | undefined;
    displayOrder?: number | undefined;
    isInternal?: boolean | undefined;
}

export class ResourcesDto implements IResourcesDto {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    display?: boolean | undefined;
    parentId?: number | undefined;
    applicationId?: number | undefined;
    attributes?: ResourceAttributeDto[] | undefined;
    permission?: PermissionDto[] | undefined;

    constructor(data?: IResourcesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.display = _data["display"];
            this.parentId = _data["parentId"];
            this.applicationId = _data["applicationId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ResourceAttributeDto.fromJS(item));
            }
            if (Array.isArray(_data["permission"])) {
                this.permission = [] as any;
                for (let item of _data["permission"])
                    this.permission!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourcesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourcesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["code"] = this.code;
        data["display"] = this.display;
        data["parentId"] = this.parentId;
        data["applicationId"] = this.applicationId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.permission)) {
            data["permission"] = [];
            for (let item of this.permission)
                data["permission"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResourcesDto {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    display?: boolean | undefined;
    parentId?: number | undefined;
    applicationId?: number | undefined;
    attributes?: ResourceAttributeDto[] | undefined;
    permission?: PermissionDto[] | undefined;
}

export class ResourcesResponseDto implements IResourcesResponseDto {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    display?: boolean | undefined;
    applicationName?: string | undefined;

    constructor(data?: IResourcesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.display = _data["display"];
            this.applicationName = _data["applicationName"];
        }
    }

    static fromJS(data: any): ResourcesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourcesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["display"] = this.display;
        data["applicationName"] = this.applicationName;
        return data;
    }
}

export interface IResourcesResponseDto {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    display?: boolean | undefined;
    applicationName?: string | undefined;
}

export class RoleCompaniesDto implements IRoleCompaniesDto {
    companyId?: number;
    companyName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean;
    canImpersonate?: boolean;
    canBeImpersonated?: boolean;
    roleDescription?: string | undefined;
    dispayText?: string | undefined;
    isCustom?: boolean;
    applicationId?: number;

    constructor(data?: IRoleCompaniesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.roleDescription = _data["roleDescription"];
            this.dispayText = _data["dispayText"];
            this.isCustom = _data["isCustom"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): RoleCompaniesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCompaniesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["roleDescription"] = this.roleDescription;
        data["dispayText"] = this.dispayText;
        data["isCustom"] = this.isCustom;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IRoleCompaniesDto {
    companyId?: number;
    companyName?: string | undefined;
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean;
    canImpersonate?: boolean;
    canBeImpersonated?: boolean;
    roleDescription?: string | undefined;
    dispayText?: string | undefined;
    isCustom?: boolean;
    applicationId?: number;
}

export class RoleExternalKeyTypePermissionsDto implements IRoleExternalKeyTypePermissionsDto {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    roleId?: number;
    permissionId?: number;
    permission?: string | undefined;
    company?: string | undefined;
    companyId?: number;

    constructor(data?: IRoleExternalKeyTypePermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalKeyTypePermissionsId = _data["externalKeyTypePermissionsId"];
            this.externalKeyTypeCode = _data["externalKeyTypeCode"];
            this.roleId = _data["roleId"];
            this.permissionId = _data["permissionId"];
            this.permission = _data["permission"];
            this.company = _data["company"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): RoleExternalKeyTypePermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleExternalKeyTypePermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalKeyTypePermissionsId"] = this.externalKeyTypePermissionsId;
        data["externalKeyTypeCode"] = this.externalKeyTypeCode;
        data["roleId"] = this.roleId;
        data["permissionId"] = this.permissionId;
        data["permission"] = this.permission;
        data["company"] = this.company;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IRoleExternalKeyTypePermissionsDto {
    externalKeyTypePermissionsId?: number;
    externalKeyTypeCode?: string | undefined;
    roleId?: number;
    permissionId?: number;
    permission?: string | undefined;
    company?: string | undefined;
    companyId?: number;
}

export class RoleHierarchicalPermissionsDto implements IRoleHierarchicalPermissionsDto {
    permissionPath?: string | undefined;
    isDeny?: boolean;

    constructor(data?: IRoleHierarchicalPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionPath = _data["permissionPath"];
            this.isDeny = _data["isDeny"];
        }
    }

    static fromJS(data: any): RoleHierarchicalPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleHierarchicalPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionPath"] = this.permissionPath;
        data["isDeny"] = this.isDeny;
        return data;
    }
}

export interface IRoleHierarchicalPermissionsDto {
    permissionPath?: string | undefined;
    isDeny?: boolean;
}

export class RoleHierarchicalPermissionsRequest implements IRoleHierarchicalPermissionsRequest {
    roleId?: number;
    permissions?: RoleHierarchicalPermissionsDto[] | undefined;

    constructor(data?: IRoleHierarchicalPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RoleHierarchicalPermissionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleHierarchicalPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RoleHierarchicalPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleHierarchicalPermissionsRequest {
    roleId?: number;
    permissions?: RoleHierarchicalPermissionsDto[] | undefined;
}

export class RoleIdDto implements IRoleIdDto {
    roleId?: number;

    constructor(data?: IRoleIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): RoleIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IRoleIdDto {
    roleId?: number;
}

export class RolePermissionsDto implements IRolePermissionsDto {
    roleId?: number;
    roleName?: string | undefined;
    roleDisplayText?: string | undefined;
    rolesDescription?: string | undefined;
    isCustom?: boolean | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    applicationId?: number | undefined;
    resources?: ResourcesDto[] | undefined;

    constructor(data?: IRolePermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayText = _data["roleDisplayText"];
            this.rolesDescription = _data["rolesDescription"];
            this.isCustom = _data["isCustom"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.applicationId = _data["applicationId"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(ResourcesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolePermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayText"] = this.roleDisplayText;
        data["rolesDescription"] = this.rolesDescription;
        data["isCustom"] = this.isCustom;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["applicationId"] = this.applicationId;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRolePermissionsDto {
    roleId?: number;
    roleName?: string | undefined;
    roleDisplayText?: string | undefined;
    rolesDescription?: string | undefined;
    isCustom?: boolean | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    applicationId?: number | undefined;
    resources?: ResourcesDto[] | undefined;
}

export class RolePermissionsReqDto implements IRolePermissionsReqDto {
    resource?: string | undefined;
    permission?: string | undefined;

    constructor(data?: IRolePermissionsReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"];
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): RolePermissionsReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource;
        data["permission"] = this.permission;
        return data;
    }
}

export interface IRolePermissionsReqDto {
    resource?: string | undefined;
    permission?: string | undefined;
}

export class RolePermissionsResponseDto implements IRolePermissionsResponseDto {
    resource?: string | undefined;
    permission?: string | undefined;

    constructor(data?: IRolePermissionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"];
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): RolePermissionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource;
        data["permission"] = this.permission;
        return data;
    }
}

export interface IRolePermissionsResponseDto {
    resource?: string | undefined;
    permission?: string | undefined;
}

export class RolesDto implements IRolesDto {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    companies?: string[] | undefined;

    constructor(data?: IRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.rolesDescription = _data["rolesDescription"];
            this.roleDisplayText = _data["roleDisplayText"];
            this.isCustom = _data["isCustom"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
        }
    }

    static fromJS(data: any): RolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["rolesDescription"] = this.rolesDescription;
        data["roleDisplayText"] = this.roleDisplayText;
        data["isCustom"] = this.isCustom;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        return data;
    }
}

export interface IRolesDto {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    companies?: string[] | undefined;
}

export class RolesResponse implements IRolesResponse {
    roleId?: number;

    constructor(data?: IRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): RolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IRolesResponse {
    roleId?: number;
}

export class RolesResponseDto implements IRolesResponseDto {
    roleId?: number;
    name?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    description?: string | undefined;
    displayText?: string | undefined;
    isCustom?: boolean | undefined;
    application?: ApplicationDto;
    companies?: string[] | undefined;
    externalKeyTypePermissions?: ExternKeyPermissionResponseDto[] | undefined;
    permissions?: RolePermissionsResponseDto[] | undefined;

    constructor(data?: IRolesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.description = _data["description"];
            this.displayText = _data["displayText"];
            this.isCustom = _data["isCustom"];
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
            if (Array.isArray(_data["externalKeyTypePermissions"])) {
                this.externalKeyTypePermissions = [] as any;
                for (let item of _data["externalKeyTypePermissions"])
                    this.externalKeyTypePermissions!.push(ExternKeyPermissionResponseDto.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionsResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["description"] = this.description;
        data["displayText"] = this.displayText;
        data["isCustom"] = this.isCustom;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        if (Array.isArray(this.externalKeyTypePermissions)) {
            data["externalKeyTypePermissions"] = [];
            for (let item of this.externalKeyTypePermissions)
                data["externalKeyTypePermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRolesResponseDto {
    roleId?: number;
    name?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    description?: string | undefined;
    displayText?: string | undefined;
    isCustom?: boolean | undefined;
    application?: ApplicationDto;
    companies?: string[] | undefined;
    externalKeyTypePermissions?: ExternKeyPermissionResponseDto[] | undefined;
    permissions?: RolePermissionsResponseDto[] | undefined;
}

export class UpsertRoleCommand implements IUpsertRoleCommand {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    roleCompanies?: string[] | undefined;
    externalKeyPermissions?: ExternalKeyPermissionsRequestDto[] | undefined;
    rolePermissions?: RolePermissionsReqDto[] | undefined;

    constructor(data?: IUpsertRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isInternal = _data["isInternal"];
            this.canImpersonate = _data["canImpersonate"];
            this.canBeImpersonated = _data["canBeImpersonated"];
            this.rolesDescription = _data["rolesDescription"];
            this.roleDisplayText = _data["roleDisplayText"];
            this.isCustom = _data["isCustom"];
            this.applicationName = _data["applicationName"];
            if (Array.isArray(_data["roleCompanies"])) {
                this.roleCompanies = [] as any;
                for (let item of _data["roleCompanies"])
                    this.roleCompanies!.push(item);
            }
            if (Array.isArray(_data["externalKeyPermissions"])) {
                this.externalKeyPermissions = [] as any;
                for (let item of _data["externalKeyPermissions"])
                    this.externalKeyPermissions!.push(ExternalKeyPermissionsRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RolePermissionsReqDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isInternal"] = this.isInternal;
        data["canImpersonate"] = this.canImpersonate;
        data["canBeImpersonated"] = this.canBeImpersonated;
        data["rolesDescription"] = this.rolesDescription;
        data["roleDisplayText"] = this.roleDisplayText;
        data["isCustom"] = this.isCustom;
        data["applicationName"] = this.applicationName;
        if (Array.isArray(this.roleCompanies)) {
            data["roleCompanies"] = [];
            for (let item of this.roleCompanies)
                data["roleCompanies"].push(item);
        }
        if (Array.isArray(this.externalKeyPermissions)) {
            data["externalKeyPermissions"] = [];
            for (let item of this.externalKeyPermissions)
                data["externalKeyPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertRoleCommand {
    roleId?: number;
    roleName?: string | undefined;
    isInternal?: boolean | undefined;
    canImpersonate?: boolean | undefined;
    canBeImpersonated?: boolean | undefined;
    rolesDescription?: string | undefined;
    roleDisplayText?: string | undefined;
    isCustom?: boolean | undefined;
    applicationName?: string | undefined;
    roleCompanies?: string[] | undefined;
    externalKeyPermissions?: ExternalKeyPermissionsRequestDto[] | undefined;
    rolePermissions?: RolePermissionsReqDto[] | undefined;
}

export class UsersDto implements IUsersDto {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    applicationName?: string | undefined;
    objectId?: string;
    isHavingRole?: boolean;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
            this.applicationName = _data["applicationName"];
            this.objectId = _data["objectId"];
            this.isHavingRole = _data["isHavingRole"];
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        data["applicationName"] = this.applicationName;
        data["objectId"] = this.objectId;
        data["isHavingRole"] = this.isHavingRole;
        return data;
    }
}

export interface IUsersDto {
    userId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    personId?: string | undefined;
    jobTitle?: string | undefined;
    applicationName?: string | undefined;
    objectId?: string;
    isHavingRole?: boolean;
}

export class UsersDtoGridResponseBase implements IUsersDtoGridResponseBase {
    items?: UsersDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UsersDto;

    constructor(data?: IUsersDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UsersDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? UsersDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UsersDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUsersDtoGridResponseBase {
    items?: UsersDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: UsersDto;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}